/**
 *
 * ModalContent
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import CommonResources from './CommonResources';
import ListResources from './ListResources';

const ModalContent = props => {
  const {
    data: {
      sys: {
        contentType: {
          sys: { id },
        },
      },
    },
  } = props;
  if (id === 'list') return <ListResources {...props} />;
  return <CommonResources {...props} />;
};

ModalContent.propTypes = {
  data: PropTypes.object,
};

export default ModalContent;
